/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { DELAY_ANALISYS_ROOM } from "../RoomNameConstants";

const state = {
    ID: DELAY_ANALISYS_ROOM,
    graph: null,
    jobstream: null,
    jobstreamData: {
        lastTenRunsChart: {},
        dataChartStartTime: {},
        dataChartDuration: {}
    },
    isPanelOpen: false,
};

export default state;
